import SalesSegment from "../../components/SalesSegment/SalesSegment";
import PageWrapper from "../PageWrapper/PageWrapper";

function SalesPage() {

  return (
    <PageWrapper>
      <>
        <SalesSegment />
      </>
    </PageWrapper>
  );
}

export default SalesPage;

